import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { PowerbiReportComponent } from '@next/core-lib/powerbi-embedded';
import { Environment } from 'src/environments/environment.model';

@Component({
  selector: 'app-co2-deliveries',
  templateUrl: './co2-deliveries.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PowerbiReportComponent],
})
export class CO2DeliveriesComponent {
  private readonly env = inject<Environment>(EnvironmentInjector);

  public readonly workspaceId: string;
  public readonly reportId: string;

  constructor() {
    this.workspaceId = this.env.CO2_DELIVERIES_WORKSPACE_ID;
    this.reportId = this.env.CO2_DELIVERIES_REPORT_ID;
  }
}
